import { styled } from "../../lib/styles/stitches.config";

const Blockquote = styled("blockquote", {
  marginLeft: 0,
  paddingLeft: "1.25em",
  borderLeft: "0.25em solid $link",
  color: "$mediumDark",
});

export default Blockquote;
